// extracted by mini-css-extract-plugin
module.exports = {"form":"NewCompany__form--1bR0n"};